import React from 'react';

interface ExternalRedirectProps {
  externalUrl: string;
}

const ExternalRedirect: React.FC<ExternalRedirectProps> = ({ externalUrl }) => {
  React.useEffect(() => {
    window.location.replace(externalUrl); // preserve back button functionality
  }, [externalUrl]);

  return null; // Don't render anything and redirect to external url
};

export default ExternalRedirect;
